import Api from '.';
import { IRequestResponse } from './index';
import { IDepartmentEdit } from '../Shared/interfaces';

class Employee extends Api {
    ENDPOINT = 'departments';

    create(data: IDepartmentEdit) {
        return this.post(this.ENDPOINT, data);
    }

    edit(id: number, data: IDepartmentEdit) {
        return this.put(`${this.ENDPOINT}/${id}`, data);
    }

    remove(id: number) {
        return this.delete(`${this.ENDPOINT}/${id}`);
    }

    getList(): Promise<IRequestResponse> {
        return this.get(`${this.ENDPOINT}`);
    }

    getListByChannel(channelId: number): Promise<IRequestResponse> {
        return this.get(`${this.ENDPOINT}`, { channelId });
    }
}

const employee = new Employee();

export default employee;
